import React from "react";

const GreenBuilding: React.FC = () => {
    return (
        <></>
    )
}
export default GreenBuilding;